export default {
    Abilities(state) {
        return state.abilities;
    },
    LoggedIn(state) {
        return state.isLoggedIn;
    },
}